/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPredictionStatusResponse
 */
export interface OrderPredictionStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OrderPredictionStatusResponse
     */
    available: boolean;
}

/**
 * Check if a given object implements the OrderPredictionStatusResponse interface.
 */
// @ts-ignore
export function instanceOfOrderPredictionStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "available" in value;

    return isInstance;
}

// @ts-ignore
export function OrderPredictionStatusResponseFromJSON(json: any): OrderPredictionStatusResponse {
    return OrderPredictionStatusResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderPredictionStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPredictionStatusResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'available': json['available'],
    };
}

// @ts-ignore
export function OrderPredictionStatusResponseToJSON(value?: OrderPredictionStatusResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'available': value.available,
    };
}

